import types from "../actions/actionTypes";
import initialState from "./initialState";

export default function projectItemStatussReducer(state = initialState.projectItemStatussList, action) {

    switch (action.type) {
        case types.LOAD_PROJECTITEMSTATUSS_SUCCESS:
            return action.projectItemStatussList;   
        default:
            return state;
    }
}